import React from 'react';
import {
    Wrench,
    Calculator,
    ClipboardList,
    DollarSign,
    Trophy,
    ListTodo,
    Calendar
} from 'lucide-react';

const ActivityTools = ({ activityId, attendees }) => {
    const tools = [
        { id: 'calculator', name: 'Calculator', icon: Calculator, color: 'bg-blue-100 text-blue-600' },
        { id: 'scoreboard', name: 'Scoreboard', icon: Trophy, color: 'bg-yellow-100 text-yellow-600' },
        { id: 'moneysplit', name: 'Money Split', icon: DollarSign, color: 'bg-green-100 text-green-600' },
        { id: 'todolist', name: 'To-Do List', icon: ListTodo, color: 'bg-purple-100 text-purple-600' },
        { id: 'schedule', name: 'Schedule', icon: Calendar, color: 'bg-orange-100 text-orange-600' },
        { id: 'checklist', name: 'Checklist', icon: ClipboardList, color: 'bg-teal-100 text-teal-600' },
    ];

    const handleToolClick = (toolId) => {
        alert(`${toolId} tool will be available soon!`);
    };

    return (
        <div className="bg-white p-4 rounded-xl shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                    <Wrench className="w-5 h-5 text-gray-400" />
                    <span className="font-medium">Activity Tools</span>
                </div>
                <span className="text-xs text-gray-400">
                    Coming Soon
                </span>
            </div>

            <div className="grid grid-cols-3 gap-4">
                {tools.map((tool) => (
                    <button
                        key={tool.id}
                        onClick={() => handleToolClick(tool.name)}
                        className="flex flex-col items-center"
                    >
                        <div className={`w-16 h-16 flex items-center justify-center rounded-2xl mb-2 ${tool.color} shadow-sm`}>
                            <tool.icon className="w-7 h-7" />
                        </div>
                        <span className="text-xs text-gray-600 text-center">{tool.name}</span>
                    </button>
                ))}
            </div>

            <div className="mt-3 pt-2 border-t border-gray-100">
                <p className="text-xs text-gray-400 text-center">
                    These tools will help your group coordinate activities together
                </p>
            </div>
        </div>
    );
};

export default ActivityTools;